export default __webpack_public_path__ + "assets/models/c2e5dc23f084cb073a01338547ddddd2.glb";